/**
 * Hand-off between the classic-script loader (widget.js) and the lazily
 * injected `<script type="module">` app bundle (MER-702). Keyed by the app
 * bundle URL so two widget versions on one page never share a renderer.
 */
export const WIDGET_APP_REGISTRY_KEY = '__MEO_WIDGET_APPS__';
export const WIDGET_APP_READY_EVENT = 'meo-widget-app-ready';

export function registerWidgetApp(win, url, app) {
  if (!win[WIDGET_APP_REGISTRY_KEY]) {
    win[WIDGET_APP_REGISTRY_KEY] = {};
  }
  win[WIDGET_APP_REGISTRY_KEY][url] = app;
  win.dispatchEvent(new win.CustomEvent(WIDGET_APP_READY_EVENT, { detail: { url } }));
}

export function getRegisteredWidgetApp(win, url) {
  return win?.[WIDGET_APP_REGISTRY_KEY]?.[url] || null;
}
